<template>
  <div class="content">
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <el-form ref="form" :model="formdata" label-width="120px">
          <el-form-item label="自动发送欢迎语" class="itemForm">
            <el-radio-group v-model="formdata.is_send">
              <el-radio :label="0">发送</el-radio>
              <el-radio :label="1">不发送</el-radio>
            </el-radio-group>
            <p class="titleLine">后台更新欢迎语，仅对从未编辑过欢迎语的成员名片生效，在AI雷达端编辑过欢迎语的成员则采用其编辑的欢迎语</p>
            <el-input
                type="textarea"
                maxlength="100"
                show-word-limit
                placeholder="您好,欢迎进入我的名片,有什么可以帮到您的吗?如有疑问可以在此与我沟通。"
                v-model="formdata.greeting"
            ></el-input>
          </el-form-item>
          <el-form-item label="常用语" class="itemForm">
            <p class="titleLine">最多可以添加5条</p>
            <div class="common_wrap">
              <div class="common_item" v-for="(item,index) in wordList" :key="index">
                <el-input placeholder="请输入常用语" v-model="item.text">
                  <el-button slot="append" icon="el-icon-circle-close" @click.stop="detelFn(index)"></el-button>
                </el-input>
              </div>
            </div>
            <div class="comment_btn" v-if="addBtn" @click.stop="addBtnFn">
              <span>
                <i class="el-icon-plus"></i>增加常用语
              </span>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="preview_wrap">
        <div class="chat-img">
          <img src="/static/img/chat.png" class="img"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "SettingsChat",
    data() {
      return {
        // is_send 	整型 	必填 	- 	- 	是否自动发送欢迎语(0发送、1不发送)
        // greeting 	varchar 	必填 	- 	- 	欢迎语
        // phrase 	varchar 	必填 	- 	- 	常用语[{text:"常用语1"},{"text":"常用语2"},{...}]
        formdata: {
          is_send: 0,
          greeting: "您好,欢迎进入我的名片,有什么可以帮到您的吗?如有疑问可以在此与我沟通。",
          phrase: ""
        },
        addBtn: false,
        wordList: []
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.axios
          .post('companyadmin/chat/index', {})
          .then(response => {
            if (response.data.code == 0) {
              this.formdata.is_send = response.data.info.is_send
              if(response.data.info.greeting){
                this.formdata.greeting= response.data.info.greeting
              }
              if(response.data.info.phrase){
                let phrase = JSON.parse(response.data.info.phrase)
                if(phrase.length!==0){
                  this.wordList = phrase
                }
                if(phrase.length!==5){
                  this.addBtn = true
                }
              }else{
                this.addBtn = true
              }
              loading.close();
            } else {
            }
          })
          .catch(response => {
          });
      },
      addBtnFn() {
        let text = {text: ''}
        if (this.wordList.length < 4) {
          this.wordList.push(text)
        } else if (this.wordList.length == 4) {
          this.wordList.push(text)
          this.addBtn = false
        }
      },
      detelFn(index) {
        this.wordList.splice(index, 1)
        this.addBtn = true
      },
      onSubmit() {
        if (!this.formdata.greeting) {
          this.$message({
            message: '请填写欢迎语',
            type: 'warning'
          });
          return
        }
        if (this.wordList.length !== 0) {
          let status = 0
          for (let i in this.wordList) {
            if (!this.wordList[i].text) {
              status = 1
            }
          }
          if (status === 1) {
            this.$message({
              message: '常用语不能为空',
              type: 'warning'
            });
            return
          }
          this.formdata.phrase = JSON.stringify(this.wordList)
        }else{
          this.formdata.phrase = JSON.stringify([])
        }

        this.axios
          .post('companyadmin/chat/set',  this.formdata)
          .then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '设置成功！',
              });
            } else {
            }
          })
          .catch(response => {
          });
      }
    }
  };
</script>
